import { useEffect } from 'react';

import { useStateContext } from '../store/stateContext';

export const usePageUrl = () => {
    const { state } = useStateContext();

    useEffect(() => {
        const currentPageUrl = window.location.href;
        const previousPageUrl = localStorage.getItem('current_page') || "No previous page";

        if (currentPageUrl !== previousPageUrl) {
            localStorage.setItem('previous_page', previousPageUrl);
            localStorage.setItem('current_page', currentPageUrl);
        }

        console.log("usePageUrl Widget Mounted: Current Page URL:", currentPageUrl);
        console.log("usePageUrl Previous Page URL:", previousPageUrl);
    }, [state]);

    return null
}